"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseYoutubeVideo = void 0;
const tslib_1 = require("tslib");
/// <reference types="gapi.youtube" />
const common_1 = require("@wix/wix-vod-shared/common");
const common_2 = require("@wix/wix-vod-constants/common");
const get_thumbnail_1 = tslib_1.__importDefault(require("./get-thumbnail"));
const parseYoutubeVideo = (videoData) => {
    const { player = {}, snippet = {}, contentDetails = {} } = videoData;
    const { id: maybeExternalId } = videoData;
    const { embedHtml } = player;
    const { channelId, title, description, thumbnails, tags, category, publishedAt, } = snippet;
    const { duration, videoId } = contentDetails;
    const width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
    const height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);
    const categories = (category ? [category] : []);
    let externalId = maybeExternalId;
    // >_<
    if (_.isObject(maybeExternalId)) {
        const { videoId: objectVideoId } = maybeExternalId;
        externalId = objectVideoId;
    }
    externalId = externalId || videoId;
    const mediaExternUrl = `//www.youtube.com/embed/${externalId}`;
    const coverUrl = (0, get_thumbnail_1.default)(thumbnails);
    let durationSec;
    let durationStr;
    if (duration && duration !== 'P0D') {
        durationSec = (0, common_1.convertISO8601ToSS)(duration);
        durationStr = (0, common_1.convertISO8601ToMMSS)(duration);
    }
    const partialYoutubeVideo = (0, common_1.removeUndefinedValues)({
        coverUrl,
        width,
        height,
        channelId,
        durationSec,
        durationStr,
    });
    return Object.assign(Object.assign({}, partialYoutubeVideo), { externalId,
        description,
        title, tags: tags || [], categories,
        mediaExternUrl, mediaStatus: common_2.TRANSCODING_STATUSES.READY, dealInfo: common_2.FREE_VIDEO_DEAL_INFO, videoSource: common_2.VIDEO_SOURCES.YOUTUBE, datePublish: publishedAt });
};
exports.parseYoutubeVideo = parseYoutubeVideo;
//# sourceMappingURL=video.js.map